import { combineReducers } from "redux";

import { IRootState } from "src/shared/types";
import notesReducer from "src/store/takeNotes";
import homeReducer from "src/store/home";
import categoryReducer from "src/store/category";
import detailsReducer from "src/store/details";
import loginReducer from "src/store/login";
import appReducer from "src/store/app";

const rootReducer = combineReducers<IRootState>({
  category: categoryReducer,
  notes: notesReducer,
  home: homeReducer,
  metricDetails: detailsReducer,
  login: loginReducer,
  app: appReducer,
});

export default rootReducer;
export type AppState = ReturnType<typeof rootReducer>;
